/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { BreakPoint } from '@shared/data-access/enums';
import { CommonModule } from '@angular/common';
import { DeviceService } from '@shared/data-access/services';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { ITrending } from '@shared/data-access/interfaces';
import { MediaModule } from '@shared/media/components';
import { chain } from '@core/chain';

@Component({
	imports: [HtmlSanitizerPipe, CommonModule, MediaModule],
	selector: 'pdp-trending',
	templateUrl: './trending.component.html',
	styleUrl: './trending.component.scss'
})
export class TrendingComponent implements OnInit {
	@Input()
	trendingArray: ITrending[] = [];

	chain = chain;

	isMobile = false;

	constructor(private deviceService: DeviceService) {}

	ngOnInit() {
		this.isMobile = [BreakPoint.EXTRASMALL, BreakPoint.SMALL, BreakPoint.MEDIUM].includes(
			this.deviceService.getDeviceBreakPoint()
		);
	}

	protected trackByFn(index: number, item: ITrending): string {
		return index.toString() + item.headline;
	}
}
